
import DocumentText from "../../../assets/filled/DocumentText.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentTextIcon({ className, dataTestid = "DocumentTextIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentText data-testid={dataTestid} className={classes} {...rest} />
  );
}
